const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_workspace/field/visits/$visitId.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_workspace/field/visits/$visitId.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { FieldLogVisitPendingState } from '@/features/field-log/components/FieldLogVisitPendingState';
import { fieldLogVisitId } from '@/features/field-log/lib/ids';
import { fieldLogVisitQuery } from '@/features/field-log/services/fieldLogQueries';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_workspace/field/visits/$visitId')({
  beforeLoad: requireCapabilities(has => has('metadata-library.organization.read')),
  loader: ({
    context,
    params
  }) => context.queryClient.ensureQueryData(fieldLogVisitQuery(fieldLogVisitId(params.visitId))),
  pendingComponent: FieldLogVisitPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});